module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "radio-button-custom"
  }, [_vm._l((_vm.options), function(op) {
    return [_c('span', {
      key: op.value,
      staticClass: "radio-button-custom__button"
    }, [_c('input', {
      staticClass: "radio-button-custom__radio",
      attrs: {
        "type": "radio",
        "name": _vm.radioButtonName,
        "id": op.name,
        "disabled": _vm.disabled
      },
      domProps: {
        "checked": String(_vm.value) === String(op.value),
        "value": op.value
      },
      on: {
        "input": _vm.emitInput
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": op.name
      }
    }, [_vm._v(_vm._s(op.name))])])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b20ecfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/radioButtons/RadioButton.vue
// module id = 1888
// module chunks = 0